import { useEffect, useState } from 'react';
import { useAssistantStore } from '@/stores/useAssistantStore';

export function useHealthCheck() {
  const { health, setHealth, apiBase } = useAssistantStore();
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    const check = async () => {
      try {
        const res = await fetch(`${apiBase}/health`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        });
        if (res.ok) {
          const data = await res.json();
          setHealth(data);
          setConnected(true);
        } else {
          setConnected(false);
        }
      } catch {
        setConnected(false);
        setHealth(null);
      }
    };

    check();
    const interval = setInterval(check, 5000);
    return () => clearInterval(interval);
  }, [apiBase, setHealth]);

  return { health, connected };
}
